import React, { FC } from 'react';
import * as Styled from './MBrandElement.styles';

import { MBrandElementProps, MBrandElementType } from './MBrandElement.types';

import { MLogoContainer } from '../MLogoContainer';
import { MLogoContainerBrand, MLogoContainerSize } from '../MLogoContainer/MLogoContainer.types';
import { AIcon } from '../../atoms/AIcon';
import { AImage } from '../../atoms/AImage';
import { AspectRatio, MediaQuery, ResponsiveImageSpec, generateImageRenditions } from '../../utils/ImageUtils';

const COMPONENT_NAME = 'm-web-ui-kit-MBrandElement';
const TEST_ID = 'web-ui-kit-MBrandElement';

const IMAGE_WIDTH_PX = 100;

const RESPONSIVE_IMAGE_SPECS: ResponsiveImageSpec[] = [
  {
    media: MediaQuery.MIN_WIDTH_XS,
    aspectRatio: AspectRatio.CLASSIC_HOR,
    imgWidthPx: IMAGE_WIDTH_PX,
  },
];

export const MBrandElement: FC<MBrandElementProps> = ({
  type,
  aIcon,
  aImage,
  mLogoContainer,
  logoSize = MLogoContainerSize.M,
  brand = MLogoContainerBrand.MI,
  logoColor,
  icon = '',
  iconSize,
  image,
}) => {
  const effectiveIcon = aIcon ?? { icon, size: iconSize };
  const effectiveImage = aImage?.image ?? image;
  const effectiveBrand = mLogoContainer?.aLogo32?.brand ?? brand;
  const effectiveLogoColor = mLogoContainer?.aLogo32?.color ?? logoColor ?? 'background-aware';

  let logoWidth: number;

  switch (logoSize) {
    case MLogoContainerSize.S: {
      // TODO: Confirm precise size with design
      logoWidth = 60;
      break;
    }
    case MLogoContainerSize.L: {
      // TODO: Confirm precise size with design
      logoWidth = 150;
      break;
    }
    case MLogoContainerSize.M:
    default: {
      logoWidth = 100;
      break;
    }
  }

  // TODO: Confirm whether this container should support 4:2 as well
  // Aspect Ratio 3:2
  const logoHeight = (logoWidth * 2) / 3;

  return (
    <Styled.Wrapper
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      className="d-flex justify-content-center"
    >
      <div className="d-flex flex-column align-items-center">
        {type === MBrandElementType.Logo && (
          <MLogoContainer
            brand={effectiveBrand}
            aspectRatio="3:2"
            width={logoWidth}
            height={logoHeight}
            color={effectiveLogoColor}
          />
        )}
        {type === MBrandElementType.Icon && (
          <AIcon size={effectiveIcon.size} icon={effectiveIcon.icon} className="t-accent-color" />
        )}
        {type === MBrandElementType.Image && effectiveImage?.assetPath && (
          <Styled.ImageWrapper width={IMAGE_WIDTH_PX}>
            <AImage
              image={effectiveImage}
              renditions={generateImageRenditions(RESPONSIVE_IMAGE_SPECS, effectiveImage.assetPath)}
            />
          </Styled.ImageWrapper>
        )}
      </div>
    </Styled.Wrapper>
  );
};

export { MBrandElementType, TEST_ID as M_BRAND_ELEMENT_TEST_ID };
